<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol != 'root' && rol != 'admin' && rol != 'admin-empresa'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container grid-list-xl fluid v-else>
            <v-row>
                <v-col lg="12">
                    <data-table
                        ref="tableSucursales"
                        :tableName="'Sucursales'"
                        :showAdvancedFilters="false"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        @loadModalData="loadModalData"
                        :perPage="[10, 25, 50, 100]"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar" style="padding-right: 12px;" v-if="permisos.create">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td>
                                    <div class="tblPrincipal">{{ item.nombre }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.nombre_empresa }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">
                                        {{
                                            item.direccion +
                                            ". " +
                                            item.nombre_municipio +
                                            ", " +
                                            item.nombre_estado
                                        }}
                                    </div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    small
                                                    fab
                                                    dark
                                                    @click="abrirModal('update', item)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom v-if="permisos.delete">
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    small
                                                    fab
                                                    dark
                                                    @click="eliminar(item.id, item.nombre)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>
        </v-container>

        <template>
            <v-layout row justify-center>
                <v-dialog v-model="dialog" persistent max-width="600px" scrollable>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>

                    <perfect-scrollbar style="background:#FFF">
                        <v-card elevation="0">
                            <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <img :src="imagen" class="imgModal" />
                                    <h2 class="titleModal">{{ titulo_modal }}</h2>
                                </div>
                            </v-card-title>

                            <v-card-text class="card_texto">
                                <div id="loadingModal" v-show="!finaliza_carga">
                                    <div id="loading">
                                        <v-progress-circular
                                            indeterminate
                                            :size="100"
                                            :width="7"
                                            color="blue"
                                        ></v-progress-circular>
                                    </div>
                                </div>

                                <v-container v-show="finaliza_carga" grid-list-md id="contenedor">
                                    <v-divider class="divider"></v-divider>
                                    <v-row class="px-0">
                                        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
                                            <v-text-field
                                                outlined
                                                autofocus
                                                id="primero"
                                                label="Nombre"
                                                v-model="sucursal.nombre"
                                                v-validate="'required'"
                                                data-vv-name="Nombre"
                                                :error-messages="errors.collect('Nombre')"
                                            />
                                        </v-col>

                                        <template v-if="rol == 'root'">
                                            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                                                <v-autocomplete
                                                    outlined
                                                    :items="clientes"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Cliente"
                                                    persistent-hint
                                                    v-model="cliente_value"
                                                    v-validate="'required'"
                                                    data-vv-name="Cliente"
                                                    :error-messages="errors.collect('Cliente')"
                                                />
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                                                <v-autocomplete
                                                    outlined
                                                    :items="empresas"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Empresa"
                                                    persistent-hint
                                                    v-model="empresa_value"
                                                    v-validate="'required'"
                                                    data-vv-name="Empresa"
                                                    :error-messages="errors.collect('Empresa')"
                                                />
                                            </v-col>
                                        </template>
                                        <template v-if="rol == 'admin'">
                                            <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                                                <v-autocomplete
                                                    outlined
                                                    :items="empresas"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Empresa"
                                                    persistent-hint
                                                    v-model="empresa_value"
                                                    v-validate="'required'"
                                                    data-vv-name="Empresa"
                                                    :error-messages="errors.collect('Empresa')"
                                                />
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <v-text-field
                                                    outlined
                                                    label="Código postal"
                                                    v-model="busca_cp"
                                                    v-validate="'required'"
                                                    data-vv-name="Código postal"
                                                    :error-messages="errors.collect('Código postal')"
                                                    @keyup.enter="busca_codigos()"
                                                    v-on:keydown.tab="busca_codigos()"
                                                />
                                            </v-col>

                                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <v-text-field
                                                    outlined
                                                    label="Estado"
                                                    v-model="estado"
                                                    disabled
                                                />
                                            </v-col>

                                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0">
                                                <v-text-field
                                                    outlined
                                                    label="Municipio"
                                                    v-model="municipio"
                                                    disabled
                                                />
                                            </v-col>
                                        </template>
                                        <template
                                            v-if="rol == 'root' || rol == 'admin-empresa'"
                                            class="py-0"
                                        >
                                            <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" class="py-0">
                                                <v-text-field
                                                    outlined
                                                    label="Código postal"
                                                    v-model="busca_cp"
                                                    v-validate="'required'"
                                                    data-vv-name="Código postal"
                                                    :error-messages="errors.collect('Código postal')"
                                                    @keyup.enter="busca_codigos()"
                                                    v-on:keydown.tab="busca_codigos()"
                                                    v-mask="'#####'"
                                                />
                                            </v-col>

                                            <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" class="py-0">
                                                <v-text-field
                                                    outlined
                                                    label="Estado"
                                                    v-model="estado"
                                                    disabled
                                                />
                                            </v-col>
                                            <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" class="py-0">
                                                <v-text-field
                                                    outlined
                                                    label="Municipio"
                                                    v-model="municipio"
                                                    disabled
                                                />
                                            </v-col>
                                        </template>
                                        <v-col cols="12" xs="12" sm="6" md="8" lg="8" xl="8" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Dirección"
                                                v-model="sucursal.direccion"
                                                required
                                                v-validate="'required'"
                                                data-vv-name="Dirección"
                                                :error-messages="errors.collect('Dirección')"
                                            />
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="6" md="4" lg="4" xl="4" class="py-0">
                                            <v-autocomplete
                                                outlined
                                                :items="colonias"
                                                item-text="nombre"
                                                item-value="id"
                                                label="Colonia"
                                                persistent-hint
                                                v-model="sucursal.colonia_id"
                                                v-validate="'required'"
                                                data-vv-name="Colonia"
                                                :error-messages="errors.collect('Colonia')"
                                            >
                                                <template v-if="mColonia"  v-slot:append-item>
                                                    <v-list-item>             
                                                        <v-list-item-content class="cursor-pointer"  @click="abrirModalColonia()">
                                                            <v-list-item-title style="color:#007EFF">Agregar colonia</v-list-item-title>
                                                        </v-list-item-content>
                                                    </v-list-item>
                                                </template>
                                            </v-autocomplete>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="py-0">
                                            <v-text-field
                                                outlined
                                                label="Descripción"
                                                v-model="sucursal.descripcion"
                                            />
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6" class="py-0 d-flex">
                                            <v-text-field
                                                outlined
                                                label="Distancia mínima"
                                                type="number"
                                                v-model="sucursal.distancia_checada"
                                                hint="Distancia en metros"
                                                v-validate="'numeros_positivos_sin_cero'"
                                                v-mask="'######'"
                                                data-vv-name="Distancia mínima"
                                                :error-messages="errors.collect('Distancia mínima')"
                                            >
                                            </v-text-field>
                                            <v-tooltip top class="pb-7">
                                                <template v-slot:activator="{ on }">
                                                    <v-icon color='#96999A' v-on="on" slot="activator" class="pb-7 pl-2">help_outline</v-icon>
                                                 </template>
                                                <span class="pb-7">La configuración que realices en este apartado se verá reflejado en los puntos donde el 
                                                    <br> usuario realice chequeo facial desde la aplicación móvil.</span>
                                            </v-tooltip>
                                        </v-col>
                                        <div style="margin-bottom: 15px;" v-show="sucursal.distancia_checada > 0">
                                            <transition  name="slide" mode="out-in">
                                                <div class="row px-0 mx-0 pb-4">
                                                    <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" >
                                                        <v-btn class="btnUbicacion d-flex pl-3 pr-9" elevation="0" @click="addMarker()">
                                                            <v-icon class="tamIcono outlined_v_icon d-flex justify-start" style="margin-inline-end:auto;">add_location_alt</v-icon>
                                                            Agregar ubicación
                                                        </v-btn>
                                                    </v-col>
                                                    <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="d-flex justify-start align-center">
                                                        <span style="font-size: 11px; color: grey;">
                                                            Haz clic en el marcador para eliminarlo.
                                                        </span>
                                                    </v-col>
                                                </div>
                                            </transition>

                                            <transition v-show="sucursal.distancia_checada > 0" name="slide" mode="out-in">
                                                <div class="row px-0 mx-0">
                                                    <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                                        <GmapMap
                                                            ref="mymap"
                                                            :center="coordenadas"
                                                            :zoom="14"
                                                            :options="{ streetViewControl: false }"
                                                            map-type-id="roadmap"
                                                            style="width: 500px; height: 300px"
                                                        >
                                                            <gmap-marker
                                                                v-for="(coordenada, index) in arrCoordenadas"
                                                                :key="index"
                                                                :position="coordenada"
                                                                :title="'Ubicación #' + (index + 1)"
                                                                :draggable="true"
                                                                @click="deleteMarker(index)"
                                                                @dragend="updateCoordinates($event.latLng, index)"
                                                            />
                                                        </GmapMap>
                                                    </v-col>
                                                </div>
                                            </transition>
                                        </div>
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions v-show="finaliza_carga" class="d-flex justify-end card_accion">
                                <button
                                    class="btnCerrar"
                                    @click="cerrarModal()"
                                    :disabled="loading_guardar"
                                >
                                    Cancelar
                                </button>
                                <v-btn
                                    class="btnGuardar"
                                    @click="guardar()"
                                    :loading="loading_guardar"
                                    v-if="(permisos.update) || (permisos.create && permisos.update == false && accion == 'add')"
                                >
                                    Guardar
                                </v-btn>
                            </v-card-actions>

                            <div class="px-15 pb-10" v-if="permisos.update == false && accion == 'update'">
                                <v-alert
                                    dense
                                    outlined
                                    type="error"
                                    
                                >
                                    El usuario no tiene permiso para editar el registro.
                                </v-alert>
                            </div>
                        </v-card>
                    </perfect-scrollbar>
                </v-dialog>
            </v-layout>
        </template>
         <!--MODAL COLONIA FORM-->
         <template class="borde-card">
            <v-dialog v-model="dialogColonia" persistent max-width="500px" class="borde-card">
                <v-card class="borde-card">
                    <ValidationObserver ref="formColonia" v-slot="{invalid}">

                            <v-card-title class="card_titulo padding_izquierdo padding_derecho">
                                <div class="headerModalStart">
                                    <h2 class="titleModal_700_18">Agregar colonia</h2>
                            </div>
                        </v-card-title>
                        <v-card-text class="card_texto mt-5">
                            <div id="padre" v-show="isLoadingModalColonia">
                                <div id="loading">
                                    <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                </div>
                            </div>
                            <v-container v-show="!isLoadingModalColonia" grid-list-md id="contenedor">
                                <v-row class="mt-0">
                                    <v-col cols="12" xs="12" sm="12" md="12" class="pt-0 pb-0 ma-0">
                                        <ValidationProvider v-slot="{ errors }" name="Código postal" rules="required">
                                            <v-text-field 
                                                outlined
                                                label="Código postal" 
                                                class="pa-0 ma-0" 
                                                v-model="busca_cp" 
                                                :error-messages="errors" 
                                                required
                                                disabled
                                            >
                                            </v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                    <v-col cols="12" xs="12" sm="12" md="12" class="pt-0 pb-0 ma-0">
                                        <ValidationProvider v-slot="{ errors }" name="Colonia" rules="required">
                                            <v-text-field 
                                                outlined
                                                label="Colonia" 
                                                class="pa-0 ma-0" 
                                                v-model="nombreColonia" 
                                                :error-messages="errors" 
                                                required
                                            >
                                            </v-text-field>
                                        </ValidationProvider>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>
                        <v-card-actions class="d-flex justify-end card_accion">
                            <button
                                class="btnCerrar"
                                @click="cerrarModalColonia()"
                                :disabled="isSavingColonia">
                                Cancelar
                            </button>
                            <v-btn
                                class="btnGuardar"
                                @click="guardarColonia()"
                                :disabled="invalid"
                                :loading="isSavingColonia">
                                Guardar
                            </v-btn>
                        </v-card-actions>
                    </ValidationObserver>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<script>
import sucursalApi from "../api/sucursales";
import catalogoApis from "../api/catalogos";
import clientesAPi from "../api/clientes";
import empresaApi from "../api/empresas";
import Swal from "sweetalert2";
import Notify from "@/plugins/notify";
import Datatable from "@/components/datatable/Datatable.vue";
import PerfectScrollbar from "perfect-scrollbar";

export default {
    components: {
        "data-table": Datatable,
    },
    name: "Sucursales",
    data() {
        return {
            url: "sucursales/find",
            columns: [
                {
                    label: "Nombre",
                    name: "nombre",
                    filterable: true,
                },
                {
                    label: "Empresa",
                    name: "empresa",
                    filterable: true,
                },
                {
                    label: "Dirección",
                    name: "direccion",
                    filterable: true,
                },
                {
                    label: "Opciones",
                    name: "opciones",
                    filterable: false,
                    align: 'center'
                },
            ],
            filters             : {
                activo          : true,
                paginate        : true,
                include_padres  : true,
                empresa_id      : null,
                cliente_id      : null,
                order_by        : 'nombre',
            },
            loading_guardar     : false,
            dialog              : false,
            datosLogin          : "",
            sucursal            : {
                id              : 0,
                nombre          : "",
                direccion       : "",
                estado_id       : null,
                municipio_id    : null,
                cp_id           : null,
                colonia_id      : null,
                descripcion     : "",
                empresa_id      : null,
                cliente_id      : null,
                distancia_checada: null,
                coordenadas     : null,
            },
            arrCoordenadas      : [],
            coordenadas         : {
                lat             : 19.00174,
                lng             : -99.24221,
            },
            empresas            : [],
            codigosP            : [],
            colonias            : [],
            titulo_modal        : "",
            finaliza_carga      : false,
            parametros_base     : { activo: true, paginate: false, order: "asc" },
            accion              : "",
            rol                 : "",
            clientes            : [],
            cliente_value       : null,
            empresa_value       : null,
            estado_value        : null,
            municipio_id        : null,
            codigo_postal_id    : null,
            parametros_final    : 0,
            indexMarker         : null,
            imagen              : "/static/modal/sucursal.png",
            busca_cp            : "",
            estado              : "",
            municipio           : "",
            show                : false,
              //Modal Colonia
            dialogColonia           : false,
            isLoadingModalColonia   : true,
            nombreColonia           : null,
            isSavingColonia         : false,
            mColonia                : false,

            permisos :{
                create: false,
                update: false,
                delete: false,
            }
        };
    },
    watch: {
        cliente_value: function(val) {
            if( val != null){
                this.cambiaCliente(val);
            }
        },
        busca_cp: function(val){
            if(val != null){
                if(val.length == 5){
                    this.busca_codigos();
                    this.mColonia = true;
                }
                else{
                    this.estado = "";
                    this.municipio = "";
                    this.colonias = [];
                    this.mColonia = false;
                }
            }
        }
    },
    methods: {
        busca_codigos() {
            let self = this;
            let params = {
                activo: true,
                nombre: this.busca_cp,
                include_padres: true,
            };
            catalogoApis.getCP(params).then((response) => {
                let result = response.data;
                if (result.length == 0) {
                    Notify.ErrorToast("No se encontro el Código postal.");
                    this.estado = "";
                    this.municipio = "";
                    this.colonias = [];
                    this.mColonia = false;
                    return;
                }
                this.estado = result[0].nomb_estado;
                this.municipio = result[0].nomb_mun;
                this.sucursal.estado_id = result[0].estado_id;
                this.sucursal.municipio_id = result[0].municipio_id;
                this.sucursal.cp_id = result[0].id;

                catalogoApis.getColonias({ codigo_postal_id: result[0].id, order: "asc", paginate: false }).then((response) => {
                    self.colonias = response.data;
                    if (self.accion == "update") {
                        self.finaliza_carga = true;
                    }
                })
                .catch((e) => {
                    Notify.ErrorToast("Se presento un problema al cargar las colonias.");
                    return;
                    });
            })
            .catch((e) => {
                console.log(e);
                Notify.ErrorToast("Ocurrió un error al cargar los estados y ciudades.");
            });
        },
        async getCP(id) {
            await catalogoApis.getCodigoPostal(id).then((response) => {
                this.sucursal.busca_cp = response.nombre;
                this.busca_cp = response.nombre;
                this.busca_codigos();
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los codigos postales.");
            });
        },
        listar() {
            this.resetValues();
            this.datosLogin = this.$session.get("usuario");
            this.rol = this.datosLogin.rol.name;

            if (this.rol == "admin-empresa") {
                this.empresa_value = this.filters.empresa_id = this.datosLogin.empresa_id;
            } 
            else if (this.rol == "admin") {
                this.cliente_value = this.filters.cliente_id = this.datosLogin.cliente_id;
            }
        },
        setFilters() {
            let cliente = this.cliente_value;
            let empresa = this.empresa_value;
            let cliente_id;
            let empresa_id;

            if (this.rol == "admin-empresa") {
                empresa_id = this.datosLogin.empresa_id;
            } 
            else if (this.rol == "admin") {
                cliente_id = this.datosLogin.cliente_id;
            }

            let filterParams = {
                cliente_id: cliente,
                empresa_id: empresa,
            };

            let defaultParams = {
                activo: true,
                paginate: true,
                include_padres: true,
            };

                if (filterParams != null) {
                    Object.assign(defaultParams, filterParams);
                }

            this.filters = defaultParams;
        },
        async loadModalData() {
            await this.resetValues();
            await this.getEstados();

            if (this.rol == "root") {
                this.getClientes();
            }

            if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.cambiaCliente(this.datosLogin.cliente_id);
            }
        },
        async abrirModal(accion, item = null) {
            await this.resetValues();
            this.errors.clear();
            this.accion = accion;
            this.finaliza_carga = false;

            if (this.rol == "root") {
                await this.getClientes();
            }
            if (this.rol == "admin") {
                this.cliente_value = this.datosLogin.cliente_id;
                await this.cambiaCliente(
                this.datosLogin.cliente_id,
                this.empresa_value
                );
            }
            if (this.rol == "admin-empresa") {
                this.cliente_value = this.datosLogin.cliente_id;
                this.empresa_value = this.datosLogin.empresa_id;
            }

            $("#primero").focus();

            if (accion == "add") {
                this.titulo_modal = "Registro de sucursal";
                this.imagen = "/static/modal/empresaSucursalCreate.svg";
                setTimeout(function() { document.getElementById("btnModal").click();}, 100);
                this.finaliza_carga = true;
            } 
            else {
                this.titulo_modal = "Actualizar sucursal";
                this.imagen = "/static/modal/empresaSucursalUpdate.svg";
                setTimeout(function() {document.getElementById("btnModal").click();}, 100);

                this.sucursal.id                = item.id;
                this.sucursal.nombre            = item.nombre;
                this.sucursal.direccion         = item.direccion;
                this.sucursal.codigo_postal     = item.codigo_postal;
                this.sucursal.descripcion       = item.descripcion;
                this.cliente_value              = item.cliente_id;
                this.empresa_value              = item.empresa_id;
                this.sucursal.empresa_id        = item.empresa_id;
                this.sucursal.cliente_id        = item.cliente_id;
                this.sucursal.estado_id         = item.estado_id;
                this.sucursal.cp_id             = item.cp_id;
                this.sucursal.colonia_id        = item.colonia_id;
                this.municipio_id               = item.municipio_id;

                if (item.distancia_checada != null && item.coordenadas != null) {
                    this.sucursal.distancia_checada = item.distancia_checada;
                    this.arrCoordenadas = JSON.parse(item.coordenadas);

                    this.coordenadas.lng = parseFloat(this.arrCoordenadas[0].lng);
                    this.coordenadas.lat = parseFloat(this.arrCoordenadas[0].lat);
                } 
                else {
                    this.arrCoordenadas.push(this.coordenadas);
                }
                this.busca_cp = item.cp_nombre;
                this.estado = item.nombre_estado;
                this.municipio = item.nombre_municipio;
                await this.getCP(item.cp_id);
                this.finaliza_carga = true;
            }

            let item_coordenadas = {
                lat: this.coordenadas.lat,
                lng: this.coordenadas.lng,
            };

            this.arrCoordenadas.push(item_coordenadas);
        },
        addMarker() {
            let lat = this.arrCoordenadas[this.arrCoordenadas.length - 1].lat;
            let lng = this.arrCoordenadas[this.arrCoordenadas.length - 1].lng+0.003;
            let nuevaCordenada = { lat, lng }
            this.arrCoordenadas.push( nuevaCordenada );
        },
        deleteMarker(index) {
            if (this.arrCoordenadas.length != 1) {
                this.arrCoordenadas.splice(index, 1);
            }
        },
        updateCoordinates(event, index) {
            let item = {
                lat: parseFloat(event.lat().toFixed(5)),
                lng: parseFloat(event.lng().toFixed(5)),
            };

            this.arrCoordenadas.splice(index, 1, item);
        },
        eliminar(id, sucursal) {
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar la sucursal?",
                "Eliminar",
                () => {
                    sucursalApi.deleteSucursal(id).then((response) => {
                        this.listar();
                        this.$refs.tableSucursales.getData();
                        this.respuesta_ok("La sucursal ha sido eliminada satisfactoriamente");
                    })
                    .catch((err) => {
                        console.log(err);
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            );
        },

        getClientes() {
            let parametros = { activo: true, paginate: false };
            clientesAPi.getClientes(parametros).then((response) => {
                this.clientes = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        cambiaCliente(id, empresa = null) {
            if (this.sucursal.cliente_id != id) {
                this.empresa_value = null;
                this.sucursal.empresa_id = null;
            }
            let parametros = { activo: true, paginate: false, cliente_id: id };
            empresaApi.getEmpresas(parametros).then((response) => {
                this.empresas = response.data;
                if (this.sucursal.empresa_id != null) {
                    this.empresa_value = this.sucursal.empresa_id;
                }
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        guardar() {
            this.$validator.validate().then((result) => {
                if (result) {
                    this.loading_guardar = true;

                    this.sucursal.cliente_id = this.cliente_value;
                    this.sucursal.empresa_id = this.empresa_value;

                    this.sucursal.codigo_postal = "0";
                    /* if (this.sucursal.distancia_checada == 0) {
                        this.loading_guardar = false;
                        Notify.Error(
                                "Distancia mínima",
                                "La distancia mínima debe ser mayor a 0."
                            );
                            return;
                    } */
                    if (this.sucursal.distancia_checada > 0) {
                        if (this.arrCoordenadas.length == 0) {
                            this.loading_guardar = false;
                            Notify.Error(
                                "Nueva sucursal",
                                "Es necesario que coloques el marcador del mapa en la ubicación de la sucursal."
                            );
                            return;
                        } 
                        else {
                            this.sucursal.coordenadas = JSON.stringify(this.arrCoordenadas);
                        }
                    }

                    if (this.accion == "add") {
                        if (this.rol == "admin-empresa") {
                            this.sucursal.empresa_id = this.datosLogin.empresa_id;
                        }

                        sucursalApi.addSucursal(this.sucursal).then((response) => {
                            this.respuesta_ok("Se ha creado la sucursal correctamente");
                            this.$refs.tableSucursales.getData();
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    } 
                    else if (this.accion === "update") {
                        delete this.sucursal.busca_cp;
                        sucursalApi.updateSucursal(this.sucursal).then((response) => {
                            this.respuesta_ok("Se ha realizado la actualización correctamente");
                            this.$refs.tableSucursales.getData();
                        })
                        .catch((err) => {
                            this.respuesta_error(err);
                        });
                    }
                }
            });
        },
        cerrarModal() {
            this.dialog = false;
            this.resetValues();
        },
        resetValues() {
            this.sucursal = {
                id                  : 0,
                nombre              : "",
                direccion           : "",
                estado_id           : null,
                municipio_id        : null,
                cp_id               : null,
                colonia_id          : null,
                descripcion         : "",
                empresa_id          : null,
                cliente_id          : null,
                distancia_checada   : null,
                coordenadas         : null,
            },
            this.estado_value       = null;
            this.cliente_value      = null;
            this.empresa_value      = null;
            this.municipio_id       = null;
            this.codigo_postal_id   = null;
            this.parametros_final   = 0;
            this.loading_guardar    = false;
            this.clientes           = [];
            this.empresas           = [];
            this.arrCoordenadas     = [];
            this.busca_cp           = null;
            this.colonias           = [];
            this.estado             = "";
            this.municipio          = "";
            this.mColonia = false;
        },
        respuesta_error(err) {
            this.loading_guardar = false;
            if(typeof err.response.data.error === 'string'){
                Notify.ErrorToast(err.response.data.error);
            }else{
                let error = Object.values(err.response.data.error);
                let leyenda = ``;

                for (var i = 0; i < error.length; i++) {
                    leyenda+= `* ` + error[i] + `\n`;
                }

                Notify.ErrorToast(leyenda);
            }
        },
        respuesta_ok(msj) {
            this.listar();
            this.cerrarModal();
            Notify.Success("Operación exitosa", msj);
        },
        getGeoPosition(position) {
            this.coordenadas.lat = position.coords.latitude;
            this.coordenadas.lng = position.coords.longitude;

            this.arrCoordenadas.splice(0, 1, {
                lat: this.coordenadas.lat,
                lng: this.coordenadas.lng,
            });
        },
        init() {
            const elementScroll = document.querySelector("#scroll");
            if (elementScroll) {
                const ps = new PerfectScrollbar(elementScroll, {
                wheelSpeed: 2,
                wheelPropagation: true,
                minScrollbarLength: 20,
                suppressScrollY: true,
                });
            }
            /* $("tr th:nth-child(2)").css("width", "25%");
            $("tr th:nth-child(3)").css("width", "35%");
            $("tr th:nth-child(4)").css("width", "15%"); */
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
          //Modal Colonia
          abrirModalColonia(){
            this.dialogColonia = true
            this.isLoadingModalColonia = false
        },

        cerrarModalColonia(){
            this.dialogColonia = false
            this.nombreColonia = null
            this.isSavingColonia = false
        },
        guardarColonia(){
            this.$refs.formColonia.validate().then(success => {
                this.isSavingColonia = true;
                if(!success){
                    this.isSavingColonia = false;
                    return
                }

                let parametros = {
                    nombre: this.nombreColonia,
                    codigo_postal_id: this.sucursal.cp_id
                }

                catalogoApis.addColonia(parametros).then((res)=>{
                    Notify.Success("Operación exitosa", "La colonia se agrego correctamente")
                    this.busca_codigos()
                    this.cerrarModalColonia()
                    this.sucursal.colonia_id = res.data.id
                    this.$nextTick(()=>{
                        this.$refs.formColonia.reset()
                    })
                }).catch(err =>{
                    this.isSavingColonia = false
                    if(typeof err.response.data.error === 'string'){
                        Notify.ErrorToast(err.response.data.error)
                    }else{
                        let error = Object.values(err.response.data.error)
                        let leyenda = ``

                        for(var i=0; i < error.length; i++){
                            leyenda += `*` + error[i] + `\n`
                        }
                        Notify.ErrorToast(leyenda)
                    }
                })
            })
        },

        permisosVista(){
            let permisosStorage = JSON.parse(sessionStorage.getItem("permisos"))
            this.permisos.create = permisosStorage.includes("sucursales.store")
            this.permisos.update = permisosStorage.includes("sucursales.update")
            this.permisos.delete = permisosStorage.includes("sucursales.delete")
        },
    },
    created() {
        this.permisosVista();
        if (navigator.geolocation) {
            var options = {
                enableHighAccuracy: true,
                timeout: 10 * 1000 * 1000,
                maximumAge: 0,
            };

            navigator.geolocation.getCurrentPosition(
                this.getGeoPosition,
                () => console.error(err),
                options
            );
        } else {
            alert("No se concedieron permisos de geolocalización para la sucursal.");
        }
        this.listar();
    },
    mounted() {
        this.init();
    },
};
</script>

<style scoped>
    .btnUbicacion {
        width: 232px !important;
        height: 48px;
        border-radius: 30px;
        text-transform: capitalize;
        background:#E0E0E0 !important;
        color:#828282 !important;
    }
    .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        background: #1E2245;
        font-family: Montserrat;
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 15px;
        color: #ffffff;
    }

    .cursor-pointer{
        cursor: pointer;
    }
</style>
